import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dot-off",
  "use": "icon-dot-off-usage",
  "viewBox": "0 0 4 4",
  "content": "<symbol viewBox=\"0 0 4 4\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dot-off\">\n<circle cx=\"2\" cy=\"2\" r=\"2\" fill=\"#AFBAC5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol